<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ params.title }}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_509')" v-bind="formItemLayout">
          <a-input-number
            class="w-100"
            v-decorator="decorators.discount"
            :min="1"
            :max="100"
            :formatter="value => `${value}%`"
            :parser="value => value.replace('%', '')" />
        </a-form-item>
        <a-form-item :label="$t('scope.text_819')" v-bind="formItemLayout">
          <a-textarea
            v-decorator="decorators.description"
            :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SetDiscountDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        discount: [
          'discount',
          {
            initialValue: 1,
            rules: [
              { required: true, message: this.$t('scope.text_513') },
            ],
          },
        ],
        description: [
          'description',
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['scope']),
    ...mapState('app', {
      customer: state => state.customer,
    }),
  },
  methods: {
    doCreate (data) {
      return this.params.onManager('update', {
        id: this.params.data[0].id,
        managerArgs: {
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        values.discount = values.discount / 100
        await this.doCreate(values)
        this.loading = false
        this.$message.success(this.$t('common_396'))
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
